var nurseslounge_jobs = {
    init:function($params){
        $params = {user_id:libs.memoryGet('user_id')};
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_jobs.menu_selector(function(){
            nurseslounge_jobs.jobs_events($params, function(){
                nurseslounge_jobs.jobs_main_form_validate(function($form){
                    $params = $.extend({}, $params, libs.getObjForm($form));
                    nurseslounge_jobs.jobs_search($params);
                });
            });
        });
    },
    menu_selector:function(cback){
        $("footer").hide();
        $("#nurseslounge-jobs .nurseslounge-jobs").hide();
        libs.globalUrl();
        cback();
    },
    jobs_events:function($params, cback){
        var $jobsMain = $("#nurseslounge-jobs .nurseslounge-jobs-main form");
        var $search = $jobsMain.find("input[name='search']")[0];
        new google.maps.places.Autocomplete($search, {
            types: ['(regions)'],
            componentRestrictions: {country: "us"}
        });
        var $employerName = $jobsMain.find('input[name="employerName"]').unbind();
        nurseslounge_jobs.jobs_employer_autocomplete(
            $employerName,
            $params,
            "/jobs/autocomplete"
        );
        $jobsMain.find(".clear").unbind().click(function(){
            $jobsMain[0].reset();
        });
        var $jobsRight = $("#nurseslounge-jobs .nurseslounge-jobs .nurseslounge-jobs-right form");
        var $rightSearch = $jobsRight.find("input[name='search']")[0];
        new google.maps.places.Autocomplete($rightSearch,{
            types: ['(regions)'],
            componentRestrictions: {country: "us"}
        });
        var $rightEmployerName = $jobsRight.find('input[name="employerName"]').unbind();
        nurseslounge_jobs.jobs_employer_autocomplete(
            $rightEmployerName,
            $params,
            "/jobs/autocomplete"
        );
        $jobsRight.find(".clear").unbind().click(function(){
            $jobsRight[0].reset();
        });
        cback();
    },
    jobs_employer_autocomplete:function($target, $data, $url){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({
                        keyword:$($target).val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                $(this).autocomplete("close");
            }
        });
    },
    jobs_main_form_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-jobs .nurseslounge-jobs-main form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-jobs .nurseslounge-jobs-main form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                search: {
                    required: false,
                    maxlength: 255
                },
                employerName: {
                    required: false,
                    maxlength: 255
                },
                distance: {
                    required: true
                }
            },
            messages: {
                search: {
                    required: "The search field is required",
                    maxlength: "The search field cannot exceed 255 characters"
                },
                employerName: {
                    required: "The employer name field is not required",
                    maxlength: "The employer name cannot exceed 255 characters"
                },
                distance: {
                    required: "The distance field is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    jobs_search:function($params){
        var $jobsMain = $("#nurseslounge-jobs .nurseslounge-jobs-main");
        var $jobs = $("#nurseslounge-jobs .nurseslounge-jobs");
        var $jobListContainer = $jobs.find(".nurseslounge-jobs-left .jobs-list-container");
        var $preview = $jobListContainer.html();
        var $bindingResize;
        var $map = new google.maps.Map(document.getElementById('search-location-map'), {
            center: {lat: 29.8550297, lng: -97.9463043},
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoom: 5,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_LEFT
            },
        });
        $map.setTilt(0);
        google.maps.event.trigger($map, 'resize');
        nurseslounge_jobs.jobs_right_form_validate(function($form){
            $params = $.extend({}, $params, libs.getObjForm($form));
            $jobListContainer.html($preview).promise().done(function(){
                $jobsMain.fadeOut();
                $jobs.fadeIn();
                nurseslounge_jobs.jobs_search_request($params, function($data){
                    nurseslounge_jobs.jobs_search_map_list($params, $map, $data);
                });
            });
        });
        $jobListContainer.html($preview).promise().done(function(){
            $jobsMain.fadeOut();
            $jobs.fadeIn();
            nurseslounge_jobs.jobs_search_request($params, function($data){
                nurseslounge_jobs.jobs_search_map_list($params, $map, $data);
            });
        });
        if(!libs.isMobile()) {
            $(window).unbind('resize').resize(function () {
                try {
                    clearTimeout($bindingResize);
                } catch (e) {
                }
                $bindingResize = setTimeout(function () {
                    $params = libs.getObjForm($("#nurseslounge-jobs .nurseslounge-jobs .nurseslounge-jobs-right form"));
                    $params = $.extend({}, $params, {user_id: libs.memoryGet('user_id')});
                    $jobListContainer.html($preview).promise().done(function () {
                        $jobsMain.fadeOut();
                        $jobs.fadeIn();
                        nurseslounge_jobs.jobs_search_request($params, function ($data) {
                            nurseslounge_jobs.jobs_search_map_list($params, $map, $data);
                        });
                    });
                }, 800);
            });
        }
        $('#nurseslounge-jobs .toggle-arrow').unbind().click(function(){
            $('#nurseslounge-jobs .result-holder .result-counter').toggleClass('push-left-negative push-left-positive');
            $('#nurseslounge-jobs .result-map-marker').toggleClass('pull-left-full');
        });
    },
    jobs_right_form_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-jobs .nurseslounge-jobs .nurseslounge-jobs-right form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-jobs .nurseslounge-jobs .nurseslounge-jobs-right form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                search: {
                    required: false,
                    maxlength: 255
                },
                employerName: {
                    required: false,
                    maxlength: 255
                },
                distance: {
                    required: true
                }
            },
            messages: {
                search: {
                    required: "The search field is required",
                    maxlength: "The search field cannot exceed 255 characters"
                },
                employerName: {
                    required: "The employer name field is not required",
                    maxlength: "The employer name cannot exceed 255 characters"
                },
                distance: {
                    required: "The distance field is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    jobs_search_request:function($params, cback){
        $.ajax({
            url: "jobs/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    nurseslounge_jobs.form_set_values($data.data, function(){
                        cback($data);
                    });
                }
            }
        });
    },
    form_set_values:function($data, cback){
        var $jobs = $("#nurseslounge-jobs .nurseslounge-jobs");
        var $jobsForm = $jobs.find(".nurseslounge-jobs-right form");
        var $jobsLeft = $jobs.find(".nurseslounge-jobs-left");
        $jobsForm.find("input[name='search']").val($data.form.search);
        $jobsForm.find("input[name='employerName']").val($data.form.employer_name);
        $jobsForm.find("select[name='distance']").val($data.form.distance);
        $jobsForm.find("select[name='listingTypeId']").val($data.form.listing_type_id);
        $jobsLeft.find(".result-numbers:first").html('<strong>Showing '+$data.total+' </strong>availables<span class="link-color"> Jobs</span>')
        if(cback != undefined){
            cback();
        }
    },
    jobs_search_map_list:function($params, $map, $data){
        var $mapsMarkers = libs.memoryGet('maps_markers') ? libs.memoryGet('maps_markers') : [];
        $.each($mapsMarkers, function($i, $v){
            $v.setMap(null);
        });
        libs.memorySave('maps_markers', []);
        var $positionSave = [];
        var $bounds = new google.maps.LatLngBounds();
        var $locations = $data && $data.data && $data.data.locations && $data.data.locations ? $data.data.locations : null;
        var $locationsLength = $locations && $locations.length > 0 ? true : false;
        if($locationsLength){
            nurseslounge_jobs.add_map_marker_with_info($map, $locations, $positionSave, true, function(){
                nurseslounge_jobs.jobs_pagination($params, $locations, function(){
                    $.each($positionSave, function ($i, $v) {
                        $bounds.extend($v);
                    });
                    $map.fitBounds($bounds);
                    $map.panToBounds($bounds);
                    if($data.data.form.search != '') {
                        $map.setZoom(Math.round(14 - Math.log($data.data.form.distance) / Math.LN2) + 0.7);
                    }
                });
            });
        }else{
            nurseslounge_jobs.jobs_pagination($params, $locations, function(){
                nurseslounge_jobs.add_map_request_current_address_location($data.data.form.search, function($location){
                    if($location.lat){
                        $map.setCenter($location);
                        $map.setZoom(Math.round(14-Math.log($data.data.form.distance)/Math.LN2) + 0.7);
                    }
                });
            });
        }
        //$map.addListener("click", function(){});
    },
    jobs_pagination:function($params, $locations, cback){
        var $reload;
        var $loaded = false;
        var $jobs = $("#nurseslounge-jobs .nurseslounge-jobs");
        var $jobListContainer = $jobs.find(".nurseslounge-jobs-left .jobs-list-container");
        var $paginationContainer = $jobs.find(".nurseslounge-jobs-left .pagination-nav");
        var $previewHeight = $jobs.find(".nurseslounge-jobs-left .jobs-list-container .preview:first").innerHeight();
        var $jobHeight = $jobListContainer.innerHeight();
        var $pageSize = Math.round(($jobHeight/$previewHeight));
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('jobs_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationContainer.pagination({
            pageSize: $pageSize > 0 ? $pageSize : 0,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:$locations.filter(function($obj){
                return $obj.employer_have_clicks > 0;
            }),
            callback: function($data, $pagination) {
                $loaded = true;
                var $chtml = nurseslounge_jobs.add_map_list_html($params, $data);
                if($chtml == ''){
                    $chtml = '' +
                        '<div class="row w-100 m-0 p-0 mt-lg-5">' +
                        '   <h5 class="w-100 text-center">Jobs for this area coming soon.</h5>' +
                        '   <div class="text-center w-100">' +
                        '       <img src="/bimg/NursesLounge/googlePin.png" class="img-fluid of-contain w-60">' +
                        '   </div>' +
                        '</div>';
                }
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $jobListContainer.html('').html($chtml).promise().done(function(){
                        nurseslounge_jobs.jobs_map_events(function() {});
                    });
                });
            }
        });
        libs.memorySave('jobs_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_jobs.jobs_pagination($params, $locations, cback);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
        if (cback != undefined) {
            cback();
        }
    },
    jobs_map_events:function(cback){
        var $jobs = $("#nurseslounge-jobs .nurseslounge-jobs");
        var $jobListContainer = $jobs.find(".nurseslounge-jobs-left .jobs-list-container");
        var $spu = $jobListContainer.find('.spu');
        var $mapsMarkers = libs.memoryGet('maps_markers');
        var $originalIcon;
        var $originalMarker;
        $spu.unbind();
        $spu.click(function(){
            nurseslounge_jobs.add_map_show_spu($(this).data('key'), $(this).data('facility_key'));
        }).mouseover(function(){
            var $location = $(this).data('location').split(',');
            var $iconUrl = './../../bimg/NursesLounge/onfocus.png';
            $.each($mapsMarkers, function($i, $v){
                var $position = $v.getPosition();
                if(parseFloat($location[0]) == $position.lat() && parseFloat($location[1]) == $position.lng()){
                    $originalMarker = $v;
                    $originalIcon = $originalMarker.getIcon();
                    $originalMarker.setIcon({url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))});
                    return false;
                }
            });
        }).mouseout(function(){
            try{
                $originalMarker.setIcon($originalIcon);
            }catch (e) {

            }
        });
        if(cback != undefined){
            cback();
        }
    },
    add_map_marker_with_info:function($map, $locations, $positionSave, $isEnable, cback) {
        var $mapsMarkers = libs.memoryGet('maps_markers') ? libs.memoryGet('maps_markers') : [];
        var $userId = libs.memoryGet('user_id');
        $.each($locations, function($i, $v){
            var $employersCount = $v.employers_count;
            var $employersJobsCount = $v.employers_jobs_count;
            var $employersHaveClicks = $v.employer_have_clicks;
            var $facilitiesCount = $v.facilities_count;
            var $location = $v.location.split(',');
            var $key = $v.employer_key;
            var $content = '';
            $.each($v.employers, function($sI, $sV){
                var $jobsCount = libs.arrSumObj($sV, 'jobs_count').jobs_count;
                var $facility = $sV[0];
                var $haveClicks = parseInt($facility.clicks) > 0;
                var $postBy = $facility.post_by;
                if($haveClicks){
                    if($isEnable){
                        if($userId == 'guest'){
                            $content += '<a href="javascript:onclick=nurseslounge_jobs.add_map_show_public(\''+$key+'\');">' + $facility.facility;
                        }else {
                            $content += '<a href="javascript:onclick=nurseslounge_jobs.add_map_show_spu(\''+$key+'\',\''+$facility.key+'\');">' + $facility.facility;
                        }
                    }else{
                        $content += '<p>' + $facility.facility;
                    }
                    $content += '<p><small>Jobs('+$jobsCount+')</small></p>';
                    if($isEnable) {
                        $content += '</a>';
                    }else{
                        $content += '</p>';
                    }
                }else{
                    $content += '<p>' + $facility.facility;
                    $content += '<p><small>Jobs Presently Not Posted</small></p>';
                    $content += '</p>';
                }
            });
            var $infowindow = new google.maps.InfoWindow({
                content:$content,
                maxWidth: 400
            });
            var $position = new google.maps.LatLng(parseFloat($location[0]), parseFloat($location[1]));
            var $iconUrl;
            if($employersHaveClicks){
                $iconUrl = './../../bimg/NursesLounge/active.png';
            }else{
                $iconUrl = './../../bimg/NursesLounge/inactive.png';
            }
            var $marker = new google.maps.Marker({
                position:$position,
                map: $map,
                animation: google.maps.Animation.DROP,
                icon: {url:$iconUrl, scaledSize: (new google.maps.Size(20, 35))},
            });
            $marker.addListener('click', function() {
                $infowindow.open($map, $marker);
            });
            $mapsMarkers.push($marker);
            $positionSave.push($position);
        });
        libs.memorySave('maps_markers', $mapsMarkers);
        if(cback != undefined){
            cback();
        }
    },
    add_map_request_current_address_location:function($address, cback){
        var $geocoder = new google.maps.Geocoder;
        $geocoder.geocode({'address':$address}, function($result, $status) {
            if ($status === 'OK') {
                if ($result[0]) {
                    cback($result[0].geometry.location, $result[0].formatted_address);
                }else{
                    cback({}, 'The address can to be found');
                }
            }else{
                cback({}, 'Geolocation is not available');
            }
        });
    },
    add_map_list_html:function($params, $locations){
        var $chtml = '';
        $.each($locations, function($i, $v){
            var $employersCount = $v.employers_count;
            var $employersJobsCount = $v.employers_jobs_count;
            var $employersHaveClicks = $v.employer_have_clicks;
            var $facilitiesCount = $v.facilities_count;
            var $location = $v.location;
            var $key = $v.employer_key;
            $.each($v.employers, function($sI, $sV) {
                var $jobsCount = libs.arrSumObj($sV, 'jobs_count').jobs_count;
                var $facility = $sV[0];
                var $haveClicks = parseInt($facility.clicks) > 0;
                var $rating = $facility.lounge.rating;
                if ($haveClicks) {
                    $chtml += '' +
                        '<li class="p-3 mb-2 bg-white rounded">' +
                        '    <a href="javascript:void(0)" class="spu" data-key="' + $key + '" data-facility_key="' + $facility.key + '" data-location="' + $location + '">' +
                        '        <div class="row">' +
                        '            <div class="col-12 text-center text-sm-right">' +
                        '                <div class="d-flex clg-rating float-right mt-n3">' +
                        '                    <div class="rating-stars mr-2">';
                    for(var $i=1; $i<=5; $i++) {
                        var $star = $rating - $i;
                        var $offsetOn;
                        var $offsetOff;
                        var $unique = libs.getUniqueId();
                        if($star >= 0){
                            $offsetOn = 100;
                            $offsetOff = 0;
                        }else if($star < 0 && $star > -1){
                            $star = ($star * -1);
                            $offsetOff = ($star * 100);
                            $offsetOn = (100 - $offsetOff);
                        }else{
                            $offsetOn = 0;
                            $offsetOff = 100;
                        }
                        $chtml += '' +
                            '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percent'+$unique+')">' +
                            '   <defs>' +
                            '       <linearGradient id="percent'+$unique+'">';
                        if($offsetOn > 0) {
                            $chtml += '' +
                                '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
                        }
                        if($offsetOff > 0){
                            $chtml += '' +
                                '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
                        }
                        $chtml += '' +
                            '       </linearGradient>' +
                            '   </defs>' +
                            '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                            '</svg>';
                    }
                    $chtml += '' +
                        '                    </div>' +
                        '                    <div class="rating-count text-center text-muted text-sm-right">' +
                        '                       '+$rating+'/5' +
                        '                    </div>' +
                        '                </div>' +
                        '            </div>' +
                        '            <div class="col-12 align-self-center">' +
                        '                <div class="d-flex">' +
                        '                    <div class="profile-img mr-3">' +
                        '                        <img src="' + $facility.lounge.logo_root_lounge + '?resize=60" alt="hospital" class="p-2">' +
                        '                    </div>' +
                        '                    <div class="list-info align-self-center w-100">' +
                        '                        <h4> ' + $facility.facility + ' </h4>' +
                        '                        <p class="text-muted">' + $jobsCount + ' available at ' + $facility.name + '</p>' +
                        '                    </div>' +
                        '                </div>' +
                        '            </div>' +
                        '        </div>' +
                        '    </a>' +
                        '</li>';
                }
            });
        });
        return $chtml;
    },
    add_map_show_spu:function($key, $facilityKey){
        var $params = {
            key:$key,
            facilityKey:$facilityKey,
            user_id:libs.memoryGet('user_id')
        };
        var $userId = libs.memoryGet('user_id');
        var $employerJobsModal = $("#nurseslounge-employer-jobs-modal");
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $employerName = $employerJobsModal.find(".employer-name:first");
        var $employerPreview = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
        var $loungeImage = $employerJobsModal.find(".lounge-image:first");
        var $loungeImagePreview = '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;';
        var $loungeName = $employerJobsModal.find(".lounge-name:first");
        var $loungeNamePreview = '&nbsp;';
        var $availablesJobsDiv = $employerJobsModal.find(".availables-jobs:first");
        var $availablesJobsDivPreview = '&nbsp;';
        var $ratingStarts = $employerJobsModal.find(".rating-stars:first");
        var $ratingStartsPreview = '' +
            '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
            '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
            '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
            '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
            '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>';
        var $ratingCount = $employerJobsModal.find(".rating-count:first");
        var $ratingCountPreview = '&nbsp;';
        var $resultInfoCount = $employerJobsModal.find(".result-info-count:first");
        var $resultInfoCountPreview = '&nbsp;';
        var $jobListContainer = $employerJobsModal.find(".jobs-list-container:first");
        var $jobListContainerPreview = '';
        for(var $i=0;$i<10;$i++) {
            $jobListContainerPreview += '' +
                '<li class="list-group-item mb-0 p-1">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4 nurseslounge-employer-jobs-preload">' +
                '                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <p>' +
                '                        <a href="javascript:void(0)" class="nurseslounge-employer-jobs-preload">' +
                '                           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                           &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                        </a>' +
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '</li>';
        }
        var $paginationNav = $employerJobsModal.find(".pagination-nav:first");
        var $paginationNavPreview = '&nbsp;';
        var $search = $employerJobsModal.find('input[name="search"]');
        var $whyWorkHereButton = $employerJobsModal.find(".why-work-here:first");
        var $addReviewButton = $employerJobsModal.find(".add-review:first");
        var $addRatingStarts = $employerJobsModal.find('.clg-rating:first');
        var $employerMap = $("#employer-modal-tabs-location-map");
        var $jobRecruiter = $("#jobs-recruiters .content");
        var $jobRating = $("#jobs-rating .content");
        var $jobReview = $("#jobs-reviews .content");
        var $jobCost = $("#jobs-cost .content");
        var $sectionPreview = '&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;';
        var $positionSave = [];
        var $chtml;
        var $bounds = new google.maps.LatLngBounds();
        //clean form
        $employerName.addClass('nurseslounge-employer-jobs-preload').html($employerPreview);
        $loungeImage.addClass('nurseslounge-employer-jobs-preload').html($loungeImagePreview);
        $loungeName.addClass('nurseslounge-employer-jobs-preload').html($loungeNamePreview);
        $availablesJobsDiv.addClass('nurseslounge-employer-jobs-preload').html($availablesJobsDivPreview);
        $ratingStarts.addClass('nurseslounge-employer-jobs-preload').html($ratingStartsPreview);
        $ratingCount.addClass('nurseslounge-employer-jobs-preload').html($ratingCountPreview);
        $resultInfoCount.addClass('nurseslounge-employer-jobs-preload').html($resultInfoCountPreview);
        $jobListContainer.addClass('nurseslounge-employer-jobs-preload').html($jobListContainerPreview);
        $paginationNav.addClass('nurseslounge-employer-jobs-preload').html($paginationNavPreview);
        $employerMap.addClass('nurseslounge-employer-jobs-preload').html($sectionPreview);
        $jobRecruiter.addClass('nurseslounge-employer-jobs-preload').html($sectionPreview);
        $jobRating.addClass('nurseslounge-employer-jobs-preload').html($sectionPreview);
        $jobReview.addClass('nurseslounge-employer-jobs-preload').html($sectionPreview);
        $jobCost.addClass('nurseslounge-employer-jobs-preload').html($sectionPreview);
        $employerJobsModal.modal('show');
        nurseslounge_lounge_nursingJobs.add_map_show_spu_request($params, function($data){
            var $locations = $data && $data.data && $data.data.locations && $data.data.locations ? $data.data.locations : null;
            var $employer = $locations && $locations[0] && $locations[0].employers && $locations[0].employers[0] && $locations[0].employers[0][0] ? $locations[0].employers[0][0] : null;
            var $jobs = $data && $data.data && $data.data.jobs && $data.data.jobs ? $data.data.jobs : [];
            var $jobsSave = $jobs;
            var $availablesJobs = $data && $data.data && $data.data.total && $data.data.total ? $data.data.total : 0;
            if($employer){
                var $map = new google.maps.Map(document.getElementById('employer-modal-tabs-location-map'), {
                    center: {lat: 29.8550297, lng: -97.9463043},
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    zoom: 10
                });
                $map.setTilt(0);
                $employerName.removeClass('nurseslounge-employer-jobs-preload').html($employer.name);
                var $img = $employer && $employer.lounge && $employer.lounge.logo_root_lounge ? $employer.lounge.logo_root_lounge : '/bimg/NursesLounge/lounge-avatar.png';
                $loungeImage.removeClass('nurseslounge-employer-jobs-preload').html('<img src="'+$img+'?resize=80" alt="hospital">');
                var $name = $employer && $employer.lounge && $employer.lounge.name ? $employer.lounge.name : '';
                $loungeName.removeClass('nurseslounge-employer-jobs-preload').html($name);
                $availablesJobsDiv.removeClass('nurseslounge-employer-jobs-preload').html($availablesJobs+' available at '+$employer.facility+'</small>');
                var $rating = $employer && $employer.lounge && $employer.lounge.rating ? $employer.lounge.rating : 0;
                $ratingStarts.removeClass('nurseslounge-employer-jobs-preload').html(nurseslounge_jobs.add_stars($rating));
                $ratingCount.removeClass('nurseslounge-employer-jobs-preload').html($rating+' / 5');
                $resultInfoCount.removeClass('nurseslounge-employer-jobs-preload').html('<strong> Showing '+$employer.jobs_count+' </strong> availables <span class="link-color"> Jobs</span>');
                $jobListContainer.removeClass('nurseslounge-employer-jobs-preload').html($jobListContainerPreview);
                $paginationNav.removeClass('nurseslounge-employer-jobs-preload').html($paginationNavPreview);
                $employerMap.removeClass('nurseslounge-employer-jobs-preload');
                var $recruiter = $data && $data.data && $data.data.lounge && $data.data.lounge.recruiters ? $data.data.lounge.recruiters : [];
                var $recruiterHtml = '';
                if($recruiter.length > 0){
                    $recruiterHtml = nurseslounge_jobs.recruiters_html($recruiter);
                }else{
                    $recruiterHtml = '' +
                        '<div class="text-center w-100 mt-5">' +
                        '   <h2 class="m-5">No recruiters listed.</h2>' +
                        '</div>';
                }
                $jobRecruiter.removeClass('nurseslounge-employer-jobs-preload').html($recruiterHtml);
                var $ratingHtml = '';
                if($rating > 0){
                    $ratingHtml = '' +
                        '<div class="text-center w-100 mt-5">' +
                        nurseslounge_jobs.add_stars($rating) +
                        '   <h2 class="m-5">Rating '+$rating+' / 5'+'</h2>' +
                        '</div>';
                }else{
                    $ratingHtml = '' +
                        '<div class="text-center w-100 mt-5">' +
                        nurseslounge_jobs.add_stars(0) +
                        '<h2 class="m-5">' +
                        '<a href="javascript:void(0)" class="first-rating link-color">Be the first to give a rating.</a>' +
                        '</h2>' +
                        '</div>';
                }
                $jobRating.removeClass('nurseslounge-employer-jobs-preload').html($ratingHtml).promise().done(function(){
                    $jobRating.find('.first-rating:first').unbind().click(function(){
                        $employerJobsModal.modal('hide');
                        nurseslounge_lounge_overview.information_review($employer.lounge.lounge_type_id, $params, $data, function(){
                            $("#nurseslounge-jobs .nurseslounge-jobs .nurseslounge-jobs-right form").submit();
                            $reviewModal.modal('hide');
                        });
                    });
                });
                var $lounge = $data && $data.data && $data.data.lounge ? $data.data.lounge : null;
                var $reviews = $data && $data.data && $data.data.lounge && $data.data.lounge.reviews ? $data.data.lounge.reviews : [];
                var $jobReviewHtml = '';
                if($reviews.length > 0){
                    $jobReviewHtml = '' +
                        '<div class="col-12 p-3 mh">' +
                        nurseslounge_jobs.reviews_html($reviews, $lounge) +
                        '</div>';
                }else{
                    $jobReviewHtml = '' +
                        '<div class="text-center w-100 mt-5">' +
                        '<h2 class="m-5">' +
                        '<a href="javascript:void(0)" class="first-rating link-color">Be the first to give a review.</a>' +
                        '</h2>' +
                        '</div>';
                }
                $jobReview.removeClass('nurseslounge-employer-jobs-preload').html($jobReviewHtml).promise().done(function(){
                    $jobReview.find('.first-rating:first').unbind().click(function(){
                        $employerJobsModal.modal('hide');
                        nurseslounge_lounge_overview.information_review($employer.lounge.lounge_type_id, $params, $data, function(){
                            $("#nurseslounge-jobs .nurseslounge-jobs .nurseslounge-jobs-right form").submit();
                            $reviewModal.modal('hide');
                        });
                    });
                    $jobReview.find('.open-url').unbind().click(function(){
                        var $url = $(this).data('url');
                        window.open($url,'_blank');
                    });
                });
                nurseslounge_jobs.add_map_marker_with_info($map, $locations, $positionSave, false, function(){
                    $search.unbind().on('change keyup keydown keypress', function(){
                        var $that = $(this);
                        $jobs = $jobsSave.filter(function($v){
                            var $exp = new RegExp($that.val(),"i");
                            return $v.title.match($exp);
                        });
                        nurseslounge_jobs.jobs_popup_pagination($params, $employer.lounge, $jobs, function(){});
                    });
                    $loungeName.unbind().click(function(){
                        if($userId == 'guest'){
                            window.open($employer.lounge.public_link, '_blank');
                        }else{
                            router.navigate($employer.lounge.link,true);
                            $employerJobsModal.modal('hide');
                        }
                    });
                    $loungeImage.unbind().click(function(){
                        if($userId == 'guest'){
                            window.open($employer.lounge.public_link, '_blank');
                        }else{
                            router.navigate($employer.lounge.link,true);
                            $employerJobsModal.modal('hide');
                        }
                    });
                    $whyWorkHereButton.unbind().click(function(){
                        if($userId == 'guest'){
                            window.open($employer.lounge.public_link, '_blank');
                        }else{
                            window.open($employer.lounge.link, '_blank');
                        }
                    });
                    $addRatingStarts.unbind().click(function(){
                        $employerJobsModal.modal('hide');
                        nurseslounge_lounge_overview.information_review($employer.lounge.lounge_type_id, $params, $data, function(){
                            $("#nurseslounge-jobs .nurseslounge-jobs .nurseslounge-jobs-right form").submit();
                            $reviewModal.modal('hide');
                        });
                    });
                    nurseslounge_jobs.jobs_popup_pagination($params, $employer.lounge, $jobs, function(){
                        $.each($positionSave, function ($i, $v) {
                            $bounds.extend($v);
                        });
                        setTimeout(function(){
                            $map.fitBounds($bounds);
                            $map.panToBounds($bounds);
                            $map.setZoom(15);
                        }, 1000);
                    });
                });
            }
        });
    },
    add_map_show_public:function($key){
        var $params = $.extend({}, {key:$key}, {id:'nursingJobs'});
        public_nurseslounge_lounge_overview.login_popup($params);
    },
    reviews_html:function($reviews, $lounge){
        var $chtml = '';
        $chtml += '<ul class="list-items comments-list">';
        $.each($reviews, function($i, $v){
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded" data-key="'+$lounge.key+'">' +
                '    <div class="row pb-4 border-bottom">' +
                '        <div class="col-12 align-self-center">' +
                '            <div class="row d-flex">';
            if($lounge.lounge_type_id == 1) {
                $chtml += '' +
                    '<div class="col-12 col-md-4 pb-2 pb-sm-0 ">' +
                    '    <label class="text-muted font-weight-normal mb-0">' +
                    '       Job Title' +
                    '    </label>' +
                    '    <p>' + $v.job_title + '</p>' +
                    '</div>' +
                    '<div class="col-12 col-md-4 pb-2 pb-sm-0">' +
                    '    <label class="text-muted font-weight-normal mb-0">' +
                    '       Facility' +
                    '    </label>' +
                    '    <p>' + $v.facility + '</p>' +
                    '</div>' +
                    '<div class="col-12 col-md-4 pb-2 pb-sm-0">';
                if($v.recommend_to_friend == 'yes'){
                    $chtml+='' +
                        '<div class="row">' +
                        '   <div class="col-8 offset-4 mt-3">' +
                        '       <img src="/bimg/NursesLounge/recommended-button.png" class="img-fluid">' +
                        '   </div>' +
                        '</div>';
                }
                $chtml += '' +
                    '</div>';
            }
            if($lounge.lounge_type_id == 2){
                if($v.current_profile_id != 5){
                    $chtml += '' +
                        '<div class="col-12 col-md-4 offset-md-4 pb-2 pb-sm-0 ">' +
                        '    <label class="text-muted font-weight-normal mb-0">' +
                        '       School Degree' +
                        '    </label>' +
                        '    <p>' + $v.school_degree + '</p>' +
                        '</div>';
                }else{
                    $chtml += '' +
                        '<div class="col-12 col-md-4 offset-md-4 pb-2 pb-sm-0 "></div>';
                }
                $chtml += '' +
                    '<div class="col-12 col-md-4 pb-2 pb-sm-0">';
                if($v.recommend_to_friend == 'yes'){
                    $chtml+='' +
                        '<div class="row">' +
                        '   <div class="col-8 offset-4 offset-md-4 mt-3">' +
                        '       <img src="/bimg/NursesLounge/recommended-button.png" class="img-fluid">' +
                        '   </div>' +
                        '</div>';
                }
                $chtml += '' +
                    '</div>';
            }
            $chtml+='' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="row mt-3">' +
                '        <div class="col-sm">' +
                '            <div class="font-weight-bold mb-2">';
            if($v.current_profile_id == 5){
                $chtml+='<div class="font-weight-bold mb-2">Nurse Faculty Job Rating</div>';
            }
            if($v.pros_cons && $v.pros_cons != '') {
            $chtml += '' +
                '               Review';
            }
            $chtml+='' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-sm-auto">' +
                '            <div class="clg-rating d-flex">' +
                '                <div class="rating-count align-self-center mr-2 ">' +
                $v.overall_rating + ' / 5' +
                '                </div>' +
                '                <div class="rating-stars align-self-center mt-n2">' +
                nurseslounge_jobs.add_stars($v.overall_rating) +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="row">';
                if($v.pros_cons && $v.pros_cons != ''){
                    $chtml+='' +
                        '       <div class="col-sm-12 mb-2">' +
                        '           <div class="review-desc bg-light p-4">' +
                        '               <p>'+$v.pros_cons+'</p>' +
                        '           </div>' +
                        '       </div>';
                }
            $chtml+='' +
                '    </div>';
            if($v.answer) {
                $chtml += '' +
                    '<div class="row border-top mt-3">' +
                    '  <div class="col-sm-12">' +
                    '    <div class="result-info-count pt-3">Response from ' +
                    '       <span class="link-color font-weight-bold open-url" data-url="'+$v.answer.user.profile_url+'">' +
                    $v.answer.user.long_name +
                    '       </span>' +
                    '    </div>' +
                    '    <div class="contact-header link-color font-weight-normal">' +
                    '      <p>' +
                    $v.answer.answer +
                    '      </p>' +
                    '    </div>' +
                    '  </div>' +
                    '</div>';
            }
            $chtml += '' +
                '</li>';
        });
        $chtml += '</ul>';
        return $chtml;
    },
    recruiters_html:function($recruiters){
        var $chtml = '';
            $chtml += '' +
                '<ul class="list-group">';
            $.each($recruiters, function($k,$v){
                $chtml += '' +
                    '<li class="list-group-item">' +
                    '    <div class="row">' +
                    '        <div class="col-sm-12">' +
                    '            <div class="d-flex">' +
                    '                <div class="profile-img img-objectfit mr-3">' +
                    '                    <img src="'+$v.user.profile_image_root_wall+'" alt="recruiter">' +
                    '                </div>' +
                    '                <div class="list-info align-self-center">' +
                    '                    <h4>' +
                    '                        <a href="'+$v.user.profile_url+'" target="_blank" title="'+$v.user.long_name+'">' +
                    $v.user.long_name +
                    '                        </a>' +
                    '                    </h4>' +
                    '                </div>' +
                    '            </div>' +
                    '        </div>' +
                    '    </div>' +
                    '</li>';
            });
            $chtml += '</ul>';
        return $chtml;
    },
    add_stars:function($rating){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++) {
            var $star = $rating - $i;
            var $offsetOn;
            var $offsetOff;
            var $unique = libs.getUniqueId();
            if($star >= 0){
                $offsetOn = 100;
                $offsetOff = 0;
            }else if($star < 0 && $star > -1){
                $star = ($star * -1);
                $offsetOff = ($star * 100);
                $offsetOn = (100 - $offsetOff);
            }else{
                $offsetOn = 0;
                $offsetOff = 100;
            }
            $chtml += '' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percent'+$unique+')">' +
                '   <defs>' +
                '       <linearGradient id="percent'+$unique+'">';
            if($offsetOn > 0) {
                $chtml += '' +
                    '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
            }
            if($offsetOff > 0){
                $chtml += '' +
                    '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
            }
            $chtml += '' +
                '       </linearGradient>' +
                '   </defs>' +
                '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                '</svg>';
        }
        return $chtml;
    },
    jobs_popup_pagination:function($params, $lounge, $jobs, cback){
        var $employerJobsModal = $("#nurseslounge-employer-jobs-modal");
        var $jobListContainer = $employerJobsModal.find(".jobs-list-container:first");
        var $paginationNav = $employerJobsModal.find(".pagination-nav:first");
        var $loungeSaved = $lounge;
        var $paginationObj;
        var $chtml;
        try{
            $paginationObj = libs.memoryGet('jobs_popup_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: 10,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:$jobs,
            callback: function($data, $pagination) {
                $chtml = nurseslounge_jobs.jobs_popup_html($params, $loungeSaved, $data);
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $jobListContainer.html('').html($chtml).promise().done(function(){
                        nurseslounge_jobs.jobs_popup_events($params);
                    });
                });
            }
        });
        libs.memorySave('jobs_popup_pagination', $paginationObj);
        if (cback != undefined) {
            cback();
        }
    },
    jobs_popup_html:function($params, $loungeSaved, $jobs){
        var $userId = libs.memoryGet('user_id');
        var $img = $loungeSaved && $loungeSaved.logo_root_lounge ? $loungeSaved.logo_root_lounge : '/bimg/NursesLounge/lounge-avatar.png';
        var $chtml = '';
        $.each($jobs, function($i, $v){
            $chtml += '' +
                '<li class="list-group-item mb-0 p-1 item" data-link="'+$v.link+'" data-public_link="'+$v.public_link+'" data-key="'+$v.key+'">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4">' +
                '                   <img src="'+$img+'?resize=50" alt="hospital" class="p-2">' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <p>' +
                '                        <a href="javascript:void(0)">' + $v.title +
                '                        </a>' +
                '                    </p>' +
                '                </div>' +
                '            </div>' +
                '        </div>';
            if($userId != 'guest' && $v.lounge.isOwner){
            $chtml += '' +
                '        <div>' +
                '           <button type="button" class="btn btn-light pin-it my-1 mr-4">Pin IT!</button>' +
                '        </div>';
            }
            $chtml += '' +
                '    </div>' +
                '</li>';
        });
        return $chtml;
    },
    jobs_popup_events:function($params){
        var $key = $params.key;
        var $userId = libs.memoryGet('user_id');
        var $employerJobsModal = $("#nurseslounge-employer-jobs-modal");
        var $jobListContainer = $employerJobsModal.find(".jobs-list-container:first");
        $jobListContainer.find('.item').unbind().click(function(){
            var $link = $(this).data('link');
            var $publicLink = $(this).data('public_link');
            if($userId == 'guest'){
                $employerJobsModal.modal('hide');
                var $params = $.extend({}, {key:$key}, {id:'nursingJobs'});
                public_nurseslounge_lounge_overview.login_popup($params);
                //window.open($publicLink, '_blank', '');
            }else{
                window.open($link, '_blank', '');
            }
        });
        $jobListContainer.find('.pin-it').unbind().click(function($e){
            $e.stopPropagation();
            $e.preventDefault();
            var $modal = $("#nurseslounge-employer-jobs-modal");
            var $that = $(this);
            var $key = $that.parents('.item:first').data('key');
            nurseslounge_lounge_activity.pin_it({user_id:$userId, key:$key, theme:'job'}, function(){
                $modal.modal('hide');
            });
        });
    }
};
